import Chip from '@mui/material/Chip'
import { observer } from 'mobx-react'

export interface TagItem {
  uuid: string
  name: string
  color?: string
}

export interface InputProps {
  label: string
  backgroundColor?: string
  handleDelete?: () => void
}

const Tag = observer(({ label, backgroundColor, handleDelete }: InputProps) => {
  return (
    <Chip
      label={label}
      variant="filled"
      sx={{
        maxWidth: '400px',
        color: 'white',
        fontSize: '0.9rem',
        fontWeight: 'bold',
        backgroundColor: backgroundColor ?? '#00AEA6',
        '& .MuiChip-deleteIcon': {
          color: 'white',
          '&:hover': {
            color: '#2F5473'
          }
        }
      }}
      onDelete={handleDelete}
    />
  )
})

export default Tag
